import { ACTIONS as commonActions } from '@common/InviteMemberModal/state/actions';

export const ACTIONS = {
  ...commonActions,
  SET_ACCOUNT_ACCESS_LEVEL: 'setAccountAccessLevel',
};
